import React, { useEffect } from 'react'
import { db } from '../..';
import { get, ref } from 'firebase/database';
import { Link } from 'react-router-dom';

const CoinHistory = ({userData}) => {
    const [history, setHistory] = React.useState([]);

    useEffect(() => {
        if(!userData.uid) return;
        setHistory([]);

        // クレジットの使用・購入履歴を取得
        get(ref(db, 'userCoins/' + userData.uid)).then((snapshot) => {
            if (snapshot.exists()) {
                const historyData = snapshot.val().history;
                setHistory(historyData ? Object.keys(historyData).map((key) => ({...historyData[key], key: key})) : []);
            }
        }).catch((error) => {
            console.error('クレジット履歴の取得に失敗しました:', error);
        });
    }, [userData]);


    return (
        <div className='p-3 max-w-3xl mx-auto pt-6 mb-3'>
            <h1 className='text-3xl text-center mb-8'><i className="bi bi-coin me-2"></i>クレジットの使用・購入履歴</h1>

            <div className='bg-white shadow rounded-lg overflow-hidden'>
                <div className='overflow-x-auto max-h-[70vh] overflow-y-auto'>
                    <table className='w-full'>
                        <thead className='bg-gray-100 sticky top-0'>
                            <tr>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700 whitespace-nowrap'>日時</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700'>種別</th>
                                <th className='px-3 py-2 text-right text-sm font-medium text-gray-700 whitespace-nowrap'>増減</th>
                                <th className='px-3 py-2 text-right text-sm font-medium text-gray-700 whitespace-nowrap'>残高</th>
                                <th className='px-3 py-2 text-left text-sm font-medium text-gray-700'>詳細</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                history && history.sort((a, b) => new Date(b.date) - new Date(a.date)).map((item, index) => (
                                    <tr key={item.key || index} className='border-b hover:bg-gray-50'>
                                        <td className='px-3 py-2 whitespace-nowrap'>
                                            <div className='text-sm text-gray-700'>{new Date(item.date).toLocaleDateString()}</div>
                                            <div className='text-xs text-gray-400'>{new Date(item.date).toLocaleTimeString()}</div>
                                        </td>
                                        <td className='px-3 py-2'>
                                            <span className={'text-xs px-2 py-1 rounded-full ' + (item.useCoin ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600')}>
                                                {item.useCoin ? '使用' : '購入'}
                                            </span>
                                        </td>
                                        <td className={'px-3 py-2 text-right whitespace-nowrap font-medium ' + (item.useCoin ? 'text-red-600' : 'text-green-600')}>
                                            {item.useCoin ? '-' + item.useCoin : '+' + item.buyCoin} pt
                                        </td>
                                        <td className='px-3 py-2 text-right whitespace-nowrap text-gray-700'>{item.coin} pt</td>
                                        <td className='px-3 py-2 text-sm text-gray-600'>
                                            {item.useCoin && item.game && (
                                                <span><i className='bi bi-controller me-1'></i>{item.game.name}</span>
                                            )}
                                            {item.buyCoin && (
                                                <div>
                                                    {item.payment && item.payment.cardDetails && (
                                                        <span className='me-2'><i className='bi bi-credit-card me-1'></i>{item.payment.cardDetails.card.cardBrand} **** {item.payment.cardDetails.card.last4}</span>
                                                    )}
                                                    <span className='me-2'>￥{Number(item.price).toLocaleString()}</span>
                                                    {item.payment && item.payment.receiptUrl && (
                                                        <Link to={item.payment.receiptUrl} target='_blank' className='text-blue-500 hover:underline'>領収書</Link>
                                                    )}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            }
                            {(!history || history.length === 0) && (
                                <tr>
                                    <td colSpan={5} className='px-3 py-8 text-center text-gray-400'>履歴はありません</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default CoinHistory
